import { Box, Stack } from '@mui/material';
import {
  PasswordInput,
  SelectInput,
  useRecordContext,
  useTranslate,
  email,
  minLength,
  required,
} from 'react-admin';
import { useFormContext } from 'react-hook-form';
import XTextInput from '../XTextInput';
import { SelectListAgencyInput } from '../common';
import { useAuthProviders } from 'src/hooks/use-auth-providers';

export interface IUserFormProps {
  isCreate: boolean;
  showAgency?: boolean; // Optional: cho phép config từ ngoài
}

export const UserForm = (props: IUserFormProps) => {
  const { isCreate, showAgency = true } = props;
  const translate = useTranslate();
  const { password: passwordLoginEnabled } = useAuthProviders();
  const { watch } = useFormContext();
  const record = useRecordContext();
  const groupId = isCreate ? watch('groupId') : record?.groups?.[0];
  const isShowAgencyField = showAgency && ['agency', 'agency_operator'].includes(groupId);

  return (
    <Box sx={{ pt: 3, pb: 3 }}>
      <Stack spacing={3}>
        <XTextInput
          source="username"
          label="module.user.username"
          validate={[required()]}
          disabled={!isCreate}
        />
        <XTextInput
          source="email"
          label="module.user.email"
          validate={[required(), email()]}
          disabled={!isCreate}
        />

        {isShowAgencyField && (
          <SelectListAgencyInput
            source="agencies"
            label="module.user.agency"
            multiple={false}
            validate={[required()]}
            format={(value) => {
              if (Array.isArray(value) && value.length > 0) {
                return value[0];
              }
              return value;
            }}
          />
        )}

        {isCreate && passwordLoginEnabled && (
          <PasswordInput
            source="password"
            label="module.user.password"
            validate={[required(), minLength(8)]}
          />
        )}
        <SelectInput
          source="isVerified"
          label="module.user.isVerified"
          choices={[
            { id: true, name: 'Yes' },
            { id: false, name: 'No' },
          ]}
          validate={[required()]}
        />
      </Stack>
    </Box>
  );
};

export default UserForm;
